module.exports = __webpack_public_path__ + "img/giant_express.a906b38c.jpg";